//#region Libraries
import { useEffect, useRef, useState } from "react";
//#endregion
//#region Styles
import { 
    Container, 
    Tabs, Tab,
    Cursor } from "./styles";
//#endregion

const CustomTabs = ({
    viewTabTitles = [],
    currentTabIdx = 0, changeCurrentTabIdx,
    tabWidth, disabled = false
}) => {
    const $tab = useRef();
    const [cursorWidth, setCursorWidth] = useState();
    useEffect(() => {
        if (!$tab.current) return;
        const handlerResizeWindow = () => {
            setCursorWidth($tab.current?.clientWidth);
        }
        handlerResizeWindow();
        window.addEventListener("resize", handlerResizeWindow);
        return () => window.removeEventListener("resize", handlerResizeWindow);
    }, [$tab.current]);
    const getClassName = (idx) => {
        const classList = [];
        currentTabIdx === idx && classList.push("current");
        disabled && classList.push("disabled");
        return classList.join(" ");
    }
    return (
        <Container>
            <Tabs>
                {viewTabTitles.map((title, idx) => {
                    return (
                        <Tab key={idx} ref={$tab}
                            className={getClassName(idx)}
                            tabWidth={tabWidth}
                            onClick={() => !disabled && changeCurrentTabIdx(idx)}>
                            {title}
                        </Tab>
                    );
                })}
            </Tabs>
            <Cursor 
                className={disabled && "disabled"}
                width={cursorWidth} 
                currentTabIdx={currentTabIdx}/>
        </Container>
    );
}

export default CustomTabs;